/**
 * @author Yaochao
 * @date 2022/2/16 17:30
 * @description
 */
import React, {useState, useRef, useEffect, forwardRef, useImperativeHandle, useCallback} from 'react'
import {Button, Empty, Input, Popover, Tabs, Select} from "antd"
import IconSearch from "../../iconfont/search";
import add_member from "./image/chatSider/add_member.png"
import remove_member from "./image/chatSider/remove_member.png"
import ZkWxClient from "../cloud/common/zkWxClient/zkWxClient";
import IconAddition from "./iconfont/addition/addition";
import IconRemoveItion from "./iconfont/removeition/removeition";
import IconEdit from "./iconfont/edit/edit";
import ZkModal from "../common/modal/zkModal";
import ZkSelectGroupLabel from "../cloud/common/zkSelectGroupLabel/zkSelectGroupLabel";
import CloudApi from "../cloud/cloud_api";
import Message from "../common/message";
import IconDeletes from "../../iconfont/delete/deletes";
import IconDeleteTag from "./iconfont/deleteTag/deleteTag";
import MyCustomer from "./common/myCustomer/myCustomer";
import MemberCompanies from "./common/memberCompanies/memberCompanies";
import Util from "../public/utils";
import ZkSelectGroupChat from "../common/selectGroupChat/zkSelectGroupChat";
import tag_empty from "../../images/common/customer/tag/tag_empty.png";
import {Link} from "react-router-dom";
import CloudPath from "../cloud/cloud_path";
import WordsArtLibrary from "./common/wordsArtLibrary/wordsArtLibrary";
import ChatRecord from "./common/chatRecord/chatRecord";
import PubSub from "pubsub-js";
import IconRightArrow from "./iconfont/rightArrow/rightArrow";
import ZkFormItem from "../common/form/zkFormItem";
import keyword_del from "../cloud/image/common/zkAddKeyword/keyword_del.png";
import AddMobileNumber from "../common/addMobileNumber/addMobileNumber";
import AvatarInfo from "./common/avatarInfo/avatarInfo";

const {TabPane} = Tabs;
const {TextArea} = Input
const {Option} = Select
export const MyContext = React.createContext('');
let talklibSend = undefined;
let obj
const ChatSider = forwardRef((props, ref) => {

    const {leftSelect} = props

    const [groupAnnouncementContent, setGroupAnnouncementContent] = useState('')
    const [searchMemberName, setSearchMemberName] = useState(false)//群的搜索成员昵称的失焦
    const addGroupLabelRef = useRef(null)//选择标签的弹框ref
    const selectGroupLabelRef = useRef(null)//选择标签的弹框ref
    const myCustomerRef = useRef(null)//选择我的客户的弹框ref
    const myClientRef = useRef(null)//选择我的客户的弹框ref
    const groupAnnouncementRef = useRef(null)//点击群公告的弹框ref
    const memberCompaniesRef = useRef(null)//点击企业成员弹框的ref
    const frimDataRef = useRef(null)//点击企业成员弹框的ref
    const deleteGroupMemberRef = useRef(null)//点击删除群成员弹框的ref
    const deleteMemberRef = useRef(null)//点击删除群成员弹框的ref
    const [selectGroupLabel, setSelectGroupLabel] = useState([])//筛选群聊的添加标签的标签
    const [allGroupLabel, setAllGroupLabel] = useState([])//筛选群聊的添加标签的标签
    const [announcement, setAnnouncement] = useState('')//存取群公告的字段
    const [deleteGroupMemberData, setDeleteGroupMemberData] = useState([])//点击删除群成员的数组
    const [announceLoading, setAnnounceLoading] = useState(false)//编辑群公告的loading
    const [addGroupTagLoading, setAddGroupTagLoading] = useState(false)//添加群标签的loading
    const [selectCustomerLoading, setSelectCustomerLoading] = useState(false)//添加我的客户的loading
    const [memberCompaniesLoading, setMemberCompaniesLoading] = useState(false)//添加企业成员的loading
    const [deleteMemberLoading, setDeleteMemberLoading] = useState(false)//添加企业成员的loading
    const [searchMember, setSearchMember] = useState([])//用来搜索群成员的数组
    const [groupMemberName, setGroupMemberName] = useState('')//用来搜索群成员的昵称的字段
    const [remaekLoading, setRemaekLoading] = useState(false)//用来编辑客户备注的loding
    const [descLoading, setDescLoading] = useState(false)//用来编辑客户描述的loding
    const [customerRemark, setCustomerRemark] = useState('')//用来保存客户备注的字段
    const [customerDesc, setCustomerDesc] = useState('')//用来保存客户描述的字段
    const remarkEditRef = useRef(null)//客户资料备注的弹框
    const descEditRef = useRef(null)//客户资料描述的弹框
    const addCustomerLabelRef = useRef(null)//客户资料添加标签的弹框
    const [addCustomerTagLoading, setAddCustomerTagLoading] = useState(false)//客户资料的添加标签loading
    const [customerInfo, setCustomerInfo] = useState({})//客户资料
    const [customerAllTag, setCustomerAllTag] = useState([])//客户资料的全部标签
    const [customerTagId, setCustomerTagId] = useState([])//客户资料的选中标签的Id
    const [customerTag, setCustomerTag] = useState([])//客户资料的选中标签的展示
    const [tempCustomerTag, setTempCustomerTag] = useState([])//客户资料的选中标签的展示
    const [tagName, setTagName] = useState('')//客户资料的标签的筛选
    const [wordsArtLibrary, setWordsArtLibrary] = useState(['1'])//话术库列表
    const [chatCustomer, setChatCustomer] = useState(false)//搜索的焦点事件
    const [content, setContent] = useState('')//搜索的参数
    const [groupId, setGroupId] = useState(9)//搜索的参数
    const [groupList, setGroupList] = useState([])//话术分组的列表
    const [tabIndex, setTabIndex] = useState('1')//tab激活的index
    const [chatData, setChatData] = useState({})//左侧聊天选中的数据
    const [sendData, setSendData] = useState(null)//

    const examineRef = useRef(null)//查看群公告的ref
    const groupWordRef = useRef(null)//
    const customerWordRef = useRef(null)//
    const newCustomerDataRef = useRef(null)//新改的客户资料的弹框
    const [mobile, setMobile] = useState([''])//新增的弹框里面的手机号结构
    const [newSaveLoading, setNewSaveLoading] = useState(false)//新增的弹框里面的手机号结构
    const addMobileNumberRef = useRef(null)
    const [tagFilter, setTagFilter] = useState(
        {
            filterType: 1,
            tags: []
        },
    )
    const [groupData, setGroupData] = useState({})//群资料

    useEffect(() => {
        setChatData(props.chatData)
    }, [props.chatData])
    useEffect(() => {
        document.oncontextmenu = function (e) {/*屏蔽浏览器默认右键事件*/
            e = e || window.event;
            return false;
        };
    }, [])

    useEffect(() => {

    }, [props.isRoom, props.wxid, props.chat_wxid])

    //获取资料接口
    function getDataInterface() {
        if (props.isRoom == 1) {//群聊
            let bodyData = {
                wxid: props.wxid,
                chat_wxid: props.chat_wxid,
                nickName: ''
            }
            let tags = []
            let groupMember = []
            CloudApi.getChatGroupInfo(bodyData, (data) => {
                if (data.announcement) {
                    setAnnouncement(data.announcement ? data.announcement : '')//群公告
                }
                if (data.tags) {
                    tags = data.tags ? data.tags : []
                }
                if (data.corpGroup) {
                    data.corpGroup.forEach((item) => {
                        item.members.forEach((el) => {
                            el.corpName = item.corpShortName
                            el.checked = false
                            el.nickName = el.nickname
                            groupMember.push(el)
                        })
                    })
                }
                setDeleteGroupMemberData(groupMember)
                setGroupData(data)

            }, (data) => {
                // Message.error(data.respMsg)
            })
            let postData = {
                name: ''
            }
            CloudApi.getGroupTagQuery(postData, (data) => {
                if (data.tagGroup) {
                    data.tagGroup.forEach((item, index) => {
                        item.tag.forEach((el, ind) => {
                            el.flag = false
                            el.tagId = el.id
                            el.tagName = el.name
                            tags.forEach((tagsItem) => {
                                if (el.id == tagsItem.tagId) {
                                    el.flag = true
                                }
                            })
                        })
                    })
                    setAllGroupLabel(data.tagGroup)
                }
            }, () => {
                // Message.error('获取标签列表失败！')
            })
        } else if (props.isRoom == 0) {//私聊
            let bodyData = {
                wxid: props.wxid,
                chat_wxid: props.chat_wxid,
            }
            CloudApi.getChatGetCustomerInfo(bodyData, (data) => {
                setCustomerRemark(data.remark ? data.remark : '')//客户备注
                setCustomerDesc(data.desc ? data.desc : '')//客户描述
                setCustomerTag(data.tags ? data.tags : [])
                setCustomerInfo(data)
            }, (data) => {
                // Message.error(data.respMsg)
            })
            //请求客户资料的标签
            CloudApi.getAccountPhoneFriendCorpTags('', (data) => {
                if (data.tagGroup) {
                    data.tagGroup.forEach((item, index) => {
                        item.tag.forEach((el, ind) => {
                            el.flag = false
                            el.tagName = el.name
                            el.tagId = el.id
                        })
                    })
                    setCustomerAllTag(data.tagGroup)
                }
            }, () => {
                // Message.error('获取客户标签失败')
            })
        }
    }

    useEffect(() => {
        // console.log('9898',props.addSelfMsg)
        talklibSend = props.talklibSend
    }, [props.talklibSend])

    //PubSub订阅消息
    useEffect(() => {
        let token = PubSub.subscribe("LINK_TO_CHAT_RECORD", (msg, data) => {
            setTabIndex(data)
        })
        return () => {
            //组件卸载，清除订阅
            PubSub.unsubscribe(token);
        }
    }, [])

    //踢人的socket
    function kickingPlayer(msg) {
        let id = msg.data.memberIds[0]
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        newGroupData.corpGroup.forEach((item) => {
            item.members = item.members.filter(el => el.customerId != id)
        })
        setGroupData(newGroupData)
    }

    //点击群公告的编辑按钮
    function groupEdit() {
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        let newAnnouncement = newGroupData.announcement
        if (newAnnouncement.length == 0) {
            newAnnouncement = '暂无群公告'
        }
        setAnnouncement(newAnnouncement)
        groupAnnouncementRef.current.show()
    }

    function Change(e) {
        setGroupAnnouncementContent(e.target.value)
    }

    //回车事件
    function enterOnChange() {
        setGroupAnnouncement(false)
    }

    //获取焦点
    function searchMemberNameFocus() {
        setSearchMemberName(true)
    }

    //失去焦点
    function searchMemberNameBlur() {
        setSearchMemberName(false)
    }

    //点击添加标签的按钮
    function addGroupLabel() {
        addGroupLabelRef.current.show()
    }

    //点击确定添加群标签
    function querySelectLabel() {
        setAddGroupTagLoading(true)
        let tags = []
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            tagIds: []
        }
        if (selectGroupLabelRef.current.exportData()) {
            selectGroupLabelRef.current.exportData().forEach((item, index) => {
                item.tag.forEach((el, ind) => {
                    if (el.flag) {
                        el.tagId = el.id
                        el.tagName = el.name
                        tags.push(el)
                    }
                })
            })
            tags.forEach((tagsItem) => {
                bodyData.tagIds.push(tagsItem.tagId)
            })
            newGroupData.tags = tags
            CloudApi.getChatAddGroupTag(bodyData, () => {
                setAddGroupTagLoading(false)
                setGroupData(newGroupData)
                setAllGroupLabel(selectGroupLabelRef.current.exportData())
                addGroupLabelRef.current.hide()
            }, () => {
                setAddGroupTagLoading(false)
            })
        }
    }

    //点击删除展示的标签
    function deleteLabel(id) {
        let newAllGroupLabel = [...allGroupLabel]
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        let tags = []
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            tagId: id
        }
        newAllGroupLabel.forEach((item, index) => {
            item.tag.forEach((el, ind) => {
                if (el.id == id) {
                    el.flag = false
                }
                if (el.flag) {
                    tags.push(el)
                }
            })
        })
        newGroupData.tags = tags
        CloudApi.getChatDelGroupTag(bodyData, () => {
            setGroupData(newGroupData)
            setAllGroupLabel(newAllGroupLabel)
        }, () => {
            // Message.error('删除群标签失败')
        })
    }

    //点击我的客户按钮
    function myCustomer() {
        myCustomerRef.current.show()
    }

    //点击企业成员的按钮
    function memberCompanies() {
        memberCompaniesRef.current.show()
    }

    //信息联动分割
    function commendContent(arr) {
        let str = arr + ""
        if (str != '') {
            let list = str.split('\n')
            return (
                list && list.map((item, index) => {
                    return <div key={index} className={'show_five_lines'}>{item}</div>
                })
            )
        }
    }

    //群公告编辑
    function announCementChange(e) {
        let value = e.target.value
        setAnnouncement(value)
    }

    //点击确定编辑群公告按钮
    function editAnnounce() {
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        if (announcement == '') {
            Message.warning('请填写群公告')
        } else {
            setAnnounceLoading(true)
            let bodyData = {
                wxid: props.wxid,
                chat_wxid: props.chat_wxid,
                announce: announcement
            }
            CloudApi.getChatEditGroupAnnounce(bodyData, () => {
                setAnnounceLoading(false)
                newGroupData.announcement = announcement
                setGroupData(newGroupData)
                groupAnnouncementRef.current.hide()
            }, () => {
                setAnnounceLoading(false)
                // Message.error('编辑群公告失败！')
            })
        }
    }

    //点击我的客户确定按钮
    function selectCustomerQuery() {
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            customerIds: []
        }
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        let groupMember = []
        if (myClientRef.current.exportData().length == 0) {
            Message.warning('请选择要添加的客户')
        } else {
            setSelectCustomerLoading(true)
            myClientRef.current.exportData().forEach((item) => {
                bodyData.customerIds.push(item.customerId)
            })
            CloudApi.getChatInviteToGroup(bodyData, (data) => {
                data.forEach((item) => {
                    item.members.forEach((el) => {
                        el.corpName = item.corpShortName
                        el.checked = false
                        el.nickName = el.nickname
                        groupMember.push(el)
                    })
                })
                setDeleteGroupMemberData(groupMember)
                newGroupData.corpGroup = data
                setGroupData(newGroupData)
                setGroupMemberName('')//清空搜索的
                myCustomerRef.current.hide()
                setSelectCustomerLoading(false)
            }, () => {
                setSelectCustomerLoading(false)
            })
        }
    }

    //点击企业成员的确定按钮
    function memberCompaniesQuery() {
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            customerIds: []
        }
        let groupMember = []
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        if (frimDataRef.current.exportData().length == 0) {
            Message.warning('请选择要添加的客户')
        } else {
            setMemberCompaniesLoading(true)
            frimDataRef.current.exportData().forEach((item) => {
                bodyData.customerIds.push(item.customerId)
            })
            CloudApi.getChatInviteToGroup(bodyData, (data) => {
                data.forEach((item) => {
                    item.members.forEach((el) => {
                        el.corpName = item.corpShortName
                        el.checked = false
                        el.nickName = el.nickname
                        groupMember.push(el)
                    })
                })
                newGroupData.corpGroup = data
                setGroupData(newGroupData)
                setDeleteGroupMemberData(groupMember)
                setGroupMemberName('')//清空搜索的
                memberCompaniesRef.current.hide()
                setMemberCompaniesLoading(false)

            }, () => {
                setMemberCompaniesLoading(false)
            })
        }
    }

    //点击删除群成员按钮
    function removeGroupChatMember() {
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            nickName: ''
        }
        let groupMember = []
        CloudApi.getChatGroupInfo(bodyData, (data) => {
            data.corpGroup.forEach((item) => {
                item.members.forEach((el) => {
                    el.corpName = item.corpShortName
                    el.checked = false
                    el.nickName = el.nickname
                    groupMember.push(el)
                })
            })
            setDeleteGroupMemberData(groupMember)
            deleteGroupMemberRef.current.show()//打开删除成员的弹框
        }, () => {
            // Message.error('获取聊天群信息失败')
        })
    }

    //点击删除成员的确定按钮
    function deleteMemberQuery() {
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            customerIds: []
        }
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        let groupMember = []
        if (deleteMemberRef.current.exportData().length == 0) {
            Message.warning('请选择要删除的客户')
        } else {
            setDeleteMemberLoading(true)
            deleteMemberRef.current.exportData().forEach((item) => {
                bodyData.customerIds.push(item.customerId)
            })
            CloudApi.getChatRemoveFromGroup(bodyData, (data) => {
                newGroupData.corpGroup = data
                data.forEach((item) => {
                    item.members.forEach((el) => {
                        el.corpName = item.corpShortName
                        el.checked = false
                        el.nickName = el.nickname
                        groupMember.push(el)
                    })
                })
                setDeleteGroupMemberData(groupMember)
                setGroupData(newGroupData)
                deleteGroupMemberRef.current.hide()
                setGroupMemberName('')//清空搜索的
                setDeleteMemberLoading(false)
            }, () => {
                setDeleteMemberLoading(false)
            })
        }
    }

    function groupMemberNameChange(e) {
        setGroupMemberName(e.target.value)
        if (e.target.value == '') {
            searchQuery(e.target.value)
        }
    }

    //搜索群成员回车事件
    function groupMemberNameEnter() {
        if (groupMemberName != '') {
            searchQuery(groupMemberName)
        }

    }

    //搜索群成员的
    function searchQuery(name) {
        let newGroupData = JSON.parse(JSON.stringify(groupData))//原始的数组
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            nickName: name
        }
        CloudApi.getChatGroupInfo(bodyData, (data) => {
            newGroupData.corpGroup = data.corpGroup
            setGroupData(newGroupData)
        }, () => {
            // Message.error('获取聊天群信息失败')
        })
    }

    //客户资料的编辑备注按钮 弹框
    // function remarkEdit() {
    //     remarkEditRef.current.show()
    // }

    //客户资料的编辑描述按钮 弹框
    function descEdit() {
        descEditRef.current.show()
    }

    //编辑客户备注的确定按钮
    function editRemark() {
        if (Util.checkRemarkLen(customerRemark)) {
            let newCustomerInfo = JSON.parse(JSON.stringify(customerInfo))
            setRemaekLoading(true)
            let bodyData = {
                wxid: props.wxid,
                chat_wxid: props.chat_wxid,
                remark: customerRemark
            }
            CloudApi.getChatEditCustomerRemark(bodyData, () => {
                setRemaekLoading(false)
                newCustomerInfo.remark = customerRemark
                setCustomerInfo(newCustomerInfo)
                remarkEditRef.current.hide()
            }, () => {
                setRemaekLoading(false)
                // Message.error('编辑客户备注失败！')
            })
        } else {
            Message.warning('客户备注不能超过20个字符')
        }
    }

    //编辑客户描述的确定按钮
    function editDesc() {
        if (Util.checkDescLen(customerDesc)) {
            let newCustomerInfo = JSON.parse(JSON.stringify(customerInfo))
            // if(customerDesc == ''){
            //     Message.warning('请填写客户描述')
            // }else {
            setDescLoading(true)
            let bodyData = {
                wxid: props.wxid,
                chat_wxid: props.chat_wxid,
                desc: customerDesc
            }
            CloudApi.getChatEditCustomerDesc(bodyData, () => {
                setDescLoading(false)
                newCustomerInfo.desc = customerDesc
                setCustomerInfo(newCustomerInfo)
                descEditRef.current.hide()
            }, () => {
                setDescLoading(false)

            })
        } else {
            Message.warning('客户描述不能超过150个字符')
        }

        // }
    }

    //客户备注的事件
    function customerRemarkChange(e) {
        let value = e.target.value
        setCustomerRemark(value)
    }

    //客户备注的事件
    function customerDescChange(e) {
        let value = e.target.value
        setCustomerDesc(value)
    }


    //点击添加客户资料的标签
    function addCustomerTag() {
        let newData = [...customerAllTag]
        let tempCustomerTag = JSON.parse(JSON.stringify(customerTag));
        newData.forEach((item, index) => {
            item.tag.forEach((el, ind) => {
                tempCustomerTag && tempCustomerTag.forEach((tagItem) => {
                    if (el.tagId == tagItem.tagId) {
                        el.flag = true
                    }
                })
            })
        })
        setTempCustomerTag(tempCustomerTag);
        setCustomerAllTag(newData)
        addCustomerLabelRef.current.show()
    }

    //点击确定添加标签按钮
    function queryCustomerLabel() {
        let tagId = []
        tempCustomerTag.forEach((item, index) => {
            tagId.push(item.tagId)
        })
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            tagIds: tagId
        }
        setAddCustomerTagLoading(true)
        CloudApi.getChatAddCustomerTag(bodyData, () => {
            setAddCustomerTagLoading(false)
            setCustomerTagId(tagId)
            setCustomerTag(JSON.parse(JSON.stringify(tempCustomerTag)))
            addCustomerLabelRef.current.hide()
        }, () => {
            setAddCustomerTagLoading(false)
            // Message.error('添加失败')
        })
    }

    //点击客户资料的添加标签的标签
    function tagClick(tag) {
        let newData = [...customerAllTag]
        newData.forEach((item, index) => {
            item.tag.forEach((el, ind) => {
                if (el.tagId == tag.tagId) {
                    el.flag = !el.flag
                }
            })
        })
        setCustomerAllTag(newData)
        let tagIndex = -1;
        tempCustomerTag.forEach((item, index) => {
            if (item.tagId == tag.tagId) {
                tagIndex = index;
            }
        })
        if (tagIndex == -1) {
            tempCustomerTag.push(tag);
        } else {
            tempCustomerTag.splice(tagIndex, 1);
        }
        setTempCustomerTag(tempCustomerTag);
    }

    //点击删除选中的客户标签
    function deleteCustomerTag(id) {
        let newData = [...customerAllTag]
        newData.forEach((item, index) => {
            item.tag.forEach((el, ind) => {
                if (el.tagId == id) {
                    el.flag = false
                }
            })
        })
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            tagId: id
        }
        let newCustomerTag = customerTag.filter(item => item.tagId != id)
        // let newCustomerTagId = customerTagId.filter(item =>item !=id)
        // console.log(newData,newCustomerTag,newCustomerTagId)
        CloudApi.getChatDelCustomerTag(bodyData, () => {
            setCustomerAllTag(newData)
            setCustomerTag(newCustomerTag)
        }, () => {
            // Message.error('删除客户标签失败')
        })
    }

    //客户资料标签的筛选
    function tagNameChange(e) {
        setTagName(e.target.value)
        if (e.target.value == '') {
            CloudApi.getAccountPhoneFriendCorpTags('', (data) => {
                data.tagGroup.forEach((item, index) => {
                    item.tag.forEach((el, ind) => {
                        el.flag = false
                        el.tagName = el.name
                        el.tagId = el.id
                        customerTag.forEach((tagItem) => {
                            if (tagItem.tagId == el.tagId) {
                                el.flag = true
                            }
                        })
                    })
                })
                setCustomerAllTag(data.tagGroup)
            }, () => {
                // Message.error('获取客户标签失败')
            })
        }
    }

    //客户资料标签的筛选的回车事件
    function tagNameEnter() {
        if (tagName != '') {
            //请求客户资料的标签
            CloudApi.getAccountPhoneFriendCorpTags(tagName, (data) => {
                data.tagGroup.forEach((item, index) => {
                    item.tag.forEach((el, ind) => {
                        el.flag = false
                        el.tagName = el.name
                        el.tagId = el.id
                        tempCustomerTag.forEach((tagItem) => {
                            if (tagItem.tagId == el.tagId) {
                                el.flag = true
                            }
                        })
                    })
                })
                setCustomerAllTag(data.tagGroup)
            }, () => {
                // Message.error('获取客户标签失败')
            })
        }
    }

    //点击查看群公告
    function examineAnnouncement() {
        let newGroupData = JSON.parse(JSON.stringify(groupData))
        let newAnnouncement = newGroupData.announcement
        if (newAnnouncement.length == 0) {
            newAnnouncement = '暂无群公告'
        }
        setAnnouncement(newAnnouncement)
        examineRef.current.show()
    }

    useImperativeHandle(ref, () => ({
        kickingPlayer: kickingPlayer,
        // receivingNewMessage:receivingNewMessage
    }));

    function tabChange(key) {
        setTabIndex(key)
    }

    useEffect(() => {
        if (tabIndex == 2) {
            getDataInterface()
        }
    }, [props.chat_wxid, tabIndex])


    function newSaveCustomerData() {
        setNewSaveLoading(true)
        let newCustomerInfo = JSON.parse(JSON.stringify(customerInfo))
        let bodyData = {
            wxid: props.wxid,
            chat_wxid: props.chat_wxid,
            remark: customerRemark,
            desc: customerDesc,
            mobile: addMobileNumberRef.current && addMobileNumberRef.current.getData() || []
        }
        CloudApi.getChatEditCustomerNewAdd(bodyData, () => {
            setNewSaveLoading(false)
            newCustomerInfo.remark = bodyData.remark
            newCustomerInfo.desc = bodyData.desc
            newCustomerInfo.mobile = bodyData.mobile
            setCustomerInfo(newCustomerInfo)
            newCustomerDataRef.current.hide()
        }, (error) => {
            Message.warning(error.respMsg)
            setNewSaveLoading(false)
        })
    }


    return (
        <MyContext.Provider value={{
            talklibSend: talklibSend,
        }}>
            {/*// 群聊资料*/}
            <div className={'user_group_information'}>
                <Tabs onChange={tabChange} activeKey={tabIndex} destroyInactiveTabPane>
                    <TabPane tab="话术库" key="1">
                        <WordsArtLibrary ref={groupWordRef} key={'group'} chat_wxid={props.chat_wxid}
                                         chatData={chatData}/>
                    </TabPane>
                    <TabPane tab={props.isRoom == 1 ?
                        <span className={'chat-tab-name'}>群资料</span> : <span className={'chat-tab-name'}>客户资料</span>
                    } key="2">
                        <>
                            {
                                props.isRoom == 1 ?
                                    <div className={'group_data_content'}>
                                        {
                                            groupData ? <div className={'whole_roll'}>
                                                <ul className={'information_announcement'}>
                                                    <li>
                                                        <div>
                                                            <span>群公告</span>
                                                            {
                                                                groupData.isOwner == 1 ? //判断是不是群主 是群主才展示
                                                                    <span className={'groupEditBtn'}
                                                                          onClick={groupEdit}>编辑</span> :
                                                                    groupData.isOwner == 0 && groupData.isManager == 1 ?  //判断是不是群主 不是群主必须是管理账号
                                                                        <span className={'groupEditBtn'}
                                                                              onClick={groupEdit}>编辑</span> :
                                                                        <span className={'groupEditBtn'}
                                                                              onClick={examineAnnouncement}>查看</span>
                                                            }
                                                        </div>
                                                        <div style={{
                                                            margin: '8px 0',
                                                            padding: '9px',
                                                            background: '#F7F7F7',
                                                            borderRadius: '2px',
                                                            boxSizing: 'border-box'
                                                        }}>
                                                            {groupData.announcement ? commendContent(groupData.announcement) : '暂无群公告'}
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div>
                                                            <span>群标签</span>
                                                            <span className={'groupEditBtn'}
                                                                  onClick={addGroupLabel.bind(this)}>添加</span>
                                                        </div>
                                                        <div>
                                                            {groupData.tags && groupData.tags.length > 0 ?
                                                                <div className={'show_group_tag'}>
                                                                    {
                                                                        groupData.tags && groupData.tags.map((item, index) => {
                                                                            return <span key={index}>
                                                    <span>{item.tagName}</span>
                                                    <label
                                                        style={{color: '#cccccc'}}
                                                        onClick={deleteLabel.bind(this, item.tagId)}><IconDeleteTag/></label>
                                                </span>
                                                                        })
                                                                    }
                                                                </div> : <div>暂无群标签</div>}</div>
                                                    </li>
                                                </ul>
                                                <div className={'information_show_member'}>
                                                    <div className={'all_member'}>
                                                        <span>全部成员（{deleteGroupMemberData.length}）</span>
                                                        <span>
                                                            <Popover
                                                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                content={<ul>
                                                                    <li onClick={myCustomer}>我的客户</li>
                                                                    <li onClick={memberCompanies}>企业成员</li>
                                                                </ul>} placement="left"
                                                                overlayClassName={'add_group_member_card'}
                                                                trigger="click">
                                                                <label
                                                                    style={{color: '#cccccc'}}><IconAddition/></label>
                                                            </Popover>
                                                            {
                                                                groupData.isOwner == 1 || groupData.isManager == 1 ?
                                                                    <label style={{marginLeft: '9px', color: '#cccccc'}}
                                                                           onClick={removeGroupChatMember}><IconRemoveItion/></label> : ''
                                                            }
                                                        </span>
                                                    </div>
                                                    <Input
                                                        className={searchMemberName ? 'chat_customer_name' : ''}
                                                        placeholder="请输入成员昵称"
                                                        bordered={searchMemberName}
                                                        prefix={<IconSearch/>}
                                                        onFocus={searchMemberNameFocus}//获取焦点
                                                        onBlur={searchMemberNameBlur}//失去焦点
                                                        value={groupMemberName}
                                                        onChange={groupMemberNameChange}
                                                        onPressEnter={groupMemberNameEnter}
                                                    />
                                                    <div className={'group_chat_Member'}>
                                                        {
                                                            groupData.corpGroup && groupData.corpGroup.map((item, index) => {
                                                                return (
                                                                    <div className={'subordinate_companies'}
                                                                         key={index}>
                                                                        {
                                                                            item.members.length > 0 ?
                                                                                <span
                                                                                    className={item.corpShortName == '微信' ? 'wx_name' : 'qy_name'}>
                                                                                    {item.corpShortName}
                                                                                </span> : ''
                                                                        }
                                                                        <div>
                                                                            {
                                                                                item.members && item.members.map((el, ind) => {
                                                                                    return (
                                                                                        <div
                                                                                            className={'group_chat_Member_single'}
                                                                                            key={ind}>
                                                                                            <div>
                                                                                                {
                                                                                                    leftSelect.lineStatus == 1 ?
                                                                                                        <Popover
                                                                                                            content={
                                                                                                                <AvatarInfo
                                                                                                                    item={el}
                                                                                                                    insider={item.insider == 1}
                                                                                                                    chatWxIdKey={'customerId'}
                                                                                                                    wxid={props.wxid}
                                                                                                                />
                                                                                                            }
                                                                                                            title=""
                                                                                                            zIndex={800} //modal的是1000， Popover默认1030
                                                                                                            trigger={['hover']}
                                                                                                            placement="leftTop"
                                                                                                            overlayClassName={'zk-chatInfo-max'}
                                                                                                        >
                                                                                                            <img
                                                                                                                src={el.avatar}/>
                                                                                                            <span>{el.nickname}</span>
                                                                                                        </Popover>
                                                                                                        :
                                                                                                        <>
                                                                                                            <img
                                                                                                                src={el.avatar}/>
                                                                                                            <span>{el.nickname}</span>
                                                                                                        </>
                                                                                                }
                                                                                                <span
                                                                                                    className={'group_manager_identifies'}>
                                                                                                    {el.isOwner == 1 ? '-群主' : ''}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : '暂无数据'
                                        }
                                    </div>
                                    :
                                    <div className={'customer_data_content'}>
                                        <div className={'whole_roll'}>
                                            <div className={'customer_data'}>
                                                <div className={'customer_name'}>
                                                    <img
                                                        src={customerInfo.avatar}/>
                                                    <span>
                                    <span>{customerInfo.nickname}</span>
                                    <span
                                        className={customerInfo.corpShortName == '微信' ? 'customer_enterprise wx_name' : 'customer_enterprise qy_name'}>
                                        {customerInfo.corpShortName ? <>@{customerInfo.corpShortName}</> : ''}
                                    </span>
                                </span>
                                                </div>
                                                <ul className={'new_customer_data_style'}>
                                                    <li onClick={() => newCustomerDataRef.current.show()}>
                                                        <div>{customerInfo.remark ? '客户备注' : '设置备注'}：</div>
                                                        <div>
                                                            <div>
                                                                {customerInfo.remark ? commendContent(customerInfo.remark) : ''}
                                                            </div>
                                                            <span><IconRightArrow/></span>
                                                        </div>
                                                    </li>
                                                    <li onClick={() => newCustomerDataRef.current.show()}>
                                                        <div>{customerInfo.desc ? '客户描述' : '设置描述'}：</div>
                                                        <div>
                                                            <div>
                                                                {customerInfo.desc ? commendContent(customerInfo.desc) : ''}
                                                            </div>
                                                            <span><IconRightArrow/></span>
                                                        </div>
                                                    </li>
                                                    <li onClick={() => newCustomerDataRef.current.show()}>
                                                        <div>手机号：</div>
                                                        <div>
                                                            <div>
                                                                {customerInfo.mobile && customerInfo.mobile.map((el, ind) => {
                                                                    return <div>{el}</div>
                                                                })}
                                                            </div>
                                                            <span><IconRightArrow/></span>
                                                        </div>
                                                    </li>
                                                    <li onClick={addCustomerTag}>
                                                        <div>{customerTag.length > 0 ? '客户标签' : '设置标签'}：</div>
                                                        <div>
                                                            <div>
                                                                <div className={'customer_tag'}>
                                                                    {
                                                                        customerTag.map((item, index) => {
                                                                            return <span key={index}>
                                                                                {item.tagName}
                                                                                <label style={{color: '#cccccc'}}
                                                                                       onClick={deleteCustomerTag.bind(this, item.tagId)}>
                                                                                    <IconDeleteTag/>
                                                                                </label>
                                                                            </span>
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                            <span><IconRightArrow/></span>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div>添加时间：</div>
                                                        <div>
                                                            <div>
                                                                {new Date(customerInfo.addTime).format('yyyy-MM-dd hh:mm')}
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div>来源：</div>
                                                        <div>
                                                            <div>
                                                                {customerInfo.from}
                                                            </div>
                                                        </div>
                                                    </li>
                                                    {
                                                        customerInfo.groups && customerInfo.groups.length > 0 ?
                                                            <li style={{flexDirection: 'column'}}>
                                                                <div
                                                                    style={{width: '110px'}}>所在群聊({customerInfo.groups.length})：
                                                                </div>
                                                                <ul className={'in_the_group_chat'}>
                                                                    {customerInfo.groups.map(item =>
                                                                        <li>
                                                                            <img src={item.groupAvatar}
                                                                                 style={{width: '40px'}}/>
                                                                            <div>
                                                                                <span>{item.groupName}</span>
                                                                                <span>群内昵称：{item.name}</span>
                                                                            </div>
                                                                        </li>
                                                                    )}
                                                                </ul>
                                                            </li> : ''
                                                    }

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </>
                    </TabPane>
                    <TabPane tab="聊天记录" key="3">
                        <ChatRecord chat_wxid={props.chat_wxid} wxid={props.wxid}/>
                    </TabPane>
                </Tabs>
            </div>
            <ZkModal
                title={'选择标签'}
                className={'modal-right-btn'}
                ref={addGroupLabelRef}
                width={'660px'}
                footer={[
                    <Button key="back" onClick={() => addGroupLabelRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={addGroupTagLoading}
                            onClick={querySelectLabel.bind(this)}>
                        确定
                    </Button>,
                ]}
            >
                <ZkSelectGroupLabel
                    data={allGroupLabel}
                    ref={selectGroupLabelRef}
                    filterType={tagFilter.filterType}
                />
            </ZkModal>
            <ZkModal
                title={'选择客户'}
                ref={myCustomerRef}
                width={'688px'}
                footer={[
                    <Button key="back" onClick={() => myCustomerRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={selectCustomerLoading} onClick={selectCustomerQuery}>
                        确定
                    </Button>,
                ]}
            >
                <MyCustomer ref={myClientRef} wxid={props.wxid} chat_wxid={props.wxid}/>
            </ZkModal>
            <ZkModal
                title={'选择企业成员'}
                ref={memberCompaniesRef}
                width={'688px'}
                footer={[
                    <Button key="back" onClick={() => memberCompaniesRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={memberCompaniesLoading} onClick={memberCompaniesQuery}>
                        确定
                    </Button>,
                ]}
            >
                <MemberCompanies ref={frimDataRef} wxid={props.wxid} chat_wxid={props.wxid}/>
            </ZkModal>
            <ZkModal title={'编辑群公告'}
                     ref={groupAnnouncementRef}
                     width={'680px'}
                     footer={[
                         <Button key="back" onClick={() => groupAnnouncementRef.current.hide()}>
                             取消
                         </Button>,
                         <Button key="submit" type="primary" loading={announceLoading} onClick={editAnnounce}>
                             确定
                         </Button>,
                     ]}
            >
                <div className={'announce_style'}>
                    <TextArea autoSize={{minRows: 7, maxRows: 7}} placeholder={'请输入群公告'} value={announcement}
                              onChange={announCementChange}/>
                </div>
            </ZkModal>
            <ZkModal
                title={'删除群成员'}
                ref={deleteGroupMemberRef}
                width={'688px'}
                footer={[
                    <Button key="back" onClick={() => deleteGroupMemberRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={deleteMemberLoading} onClick={deleteMemberQuery}>
                        确定
                    </Button>,
                ]}
            >
                <MemberCompanies ref={deleteMemberRef} deleteMember={deleteGroupMemberData}/>
            </ZkModal>
            <ZkModal
                title={'编辑客户备注'}
                ref={remarkEditRef}
                width={'680px'}
                footer={[
                    <Button key="back" onClick={() => remarkEditRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={remaekLoading} onClick={editRemark}>
                        确定
                    </Button>,
                ]}
            >
                <div className={'announce_style'}>
                    <TextArea autoSize={{minRows: 7, maxRows: 7}} placeholder={'请输入客户备注'} value={customerRemark}
                              onChange={customerRemarkChange} maxLength={20}/>
                </div>
            </ZkModal>
            <ZkModal
                title={'编辑客户描述'}
                ref={descEditRef}
                width={'680px'}
                footer={[
                    <Button key="back" onClick={() => descEditRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={descLoading} onClick={editDesc}>
                        确定
                    </Button>,
                ]}
            >
                <div className={'announce_style'}>
                    <TextArea autoSize={{minRows: 7, maxRows: 7}} placeholder={'请输入客户描述'} value={customerDesc}
                              onChange={customerDescChange} maxLength={150}/>
                </div>
            </ZkModal>
            <ZkModal
                title={'选择标签'}
                className={'modal-right-btn'}
                ref={addCustomerLabelRef}
                width={'660px'}
                footer={[
                    <Button key="back" onClick={() => addCustomerLabelRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={addCustomerTagLoading}
                            onClick={queryCustomerLabel.bind(this)}>
                        确定
                    </Button>,
                ]}
            >
                <div style={{height: '400px'}}>
                    <Input placeholder={'请输入标签'} value={tagName} onChange={tagNameChange} onPressEnter={tagNameEnter}/>
                    <div className={'tags_inModal_content'} style={{marginTop: '10px', height: '350px'}}>
                        {
                            customerAllTag ? <>
                                {
                                    customerAllTag.map((item, index) => {
                                        return <div key={index}>
                                            <div className={index > 0 ? 'send_groupName' : ''}>{item.groupName}：</div>
                                            <div className={'label_array'}>
                                                {
                                                    item.tag && item.tag.map((el, ind) => {
                                                        return <span key={el.tagId}
                                                                     className={el.flag ? 'pitch_on' : 'unselected'}
                                                                     onClick={tagClick.bind(this, el)}
                                                        >
                                                            {el.tagName}
                                                        </span>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    })
                                }
                            </> : <div style={{
                                marginTop: '12px',
                                fontWeight: '600'
                            }}>
                                <Empty
                                    image={tag_empty}
                                    description={'没有搜到相关客户标签哦~'}
                                />
                            </div>
                        }
                    </div>
                </div>
            </ZkModal>
            <ZkModal
                title={'查看群公告'}
                ref={examineRef}
                width={'660px'}
                footer={[]}
            >
                <TextArea autoSize={{minRows: 7, maxRows: 7}} placeholder={'请输入群公告'}
                          value={announcement ? announcement : '暂无群公告'}
                />
            </ZkModal>
            <ZkModal
                ref={newCustomerDataRef}
                title={'客户资料'}
                width={520}
                className={'modal-right-btn'}
                footer={[
                    <Button key="back" onClick={() => newCustomerDataRef.current.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={newSaveLoading}
                            onClick={newSaveCustomerData.bind(this)}>
                        确定
                    </Button>,
                ]}
            >
                <ZkFormItem title={'备注'} colon={true} titleWidth={'56px'} conWidth={'370px'}>
                    <div className={'task_name customer_remark'}>
                        <Input placeholder={'请输入备注信息'} maxLength={20} value={customerRemark}
                               onChange={customerRemarkChange}/>
                        <span
                            className='word-limit'>{customerRemark ? customerRemark.length + '/20' : '0/20'}</span>
                    </div>
                </ZkFormItem>
                <ZkFormItem title={'描述'} colon={true} titleWidth={'56px'} conWidth={'370px'}>
                    <div className={'task_name customer_desc'}>
                        <TextArea autoSize={{minRows: 7, maxRows: 7}} placeholder={'请输入描述信息'} value={customerDesc}
                                  onChange={customerDescChange} maxLength={150}/>
                        <span
                            className='word-limit'>{customerDesc ? customerDesc.length + '/150' : '0/150'}</span>
                    </div>
                </ZkFormItem>
                <AddMobileNumber ref={addMobileNumberRef} title={'手机号'}
                                 mobile={customerInfo.mobile ? customerInfo.mobile : []}/>
            </ZkModal>
        </MyContext.Provider>

    )
});

export default ChatSider